import { Menu, MenuToggleButton } from "@growtherapy/sprout-ui";
import { WhiteboardControlMenuItemWrapper } from "../../session";
import {
  ScreenShareControlWrapper,
  ScreenShareMenuItemsWrapper,
} from "../../session/controls/ScreenShareControl";
import { faAirplay } from "@fortawesome/pro-solid-svg-icons";
import { ControlPanelButton } from "../../components";
import { MENU_Z_INDEX_CLASSNAME } from "../../components/constants";
import { useIsZoomEnabled } from "../../hooks/useIsZoomEnabled";
import { useFeatureGate } from "@statsig/react-bindings";
import { whiteboardEnabledGate } from "../../statsig/gates";

export function SessionModeControlButtonWrapper({
  className,
}: {
  className?: string;
}) {
  const { value: isWhiteboardingEnabled } = useFeatureGate(
    whiteboardEnabledGate,
  );
  const [isZoomEnabled] = useIsZoomEnabled();

  // Whiteboarding is not scoped for the initial Zoom launch, but will be added
  // later.
  if (isZoomEnabled || !isWhiteboardingEnabled) {
    return <ScreenShareControlWrapper />;
  }

  return (
    <Menu
      className={className}
      menuClassName={MENU_Z_INDEX_CLASSNAME}
      placement="top"
      ariaLabel="Screen sharing and whiteboarding options"
      toggleButtonTooltip="Screen share or whiteboard"
      toggleButton={
        <MenuToggleButton<typeof ControlPanelButton>
          as={ControlPanelButton}
          visibleCaret={false}
          aria-label="View screen sharing and whiteboarding options"
          iconDefinition={faAirplay}
          shouldOverrideClassName
        />
      }
    >
      <ScreenShareMenuItemsWrapper />
      <WhiteboardControlMenuItemWrapper />
    </Menu>
  );
}
